import Axios from '../../networking/interceptor';
import Cookies from 'js-cookie';
import {
  driver_delivery_video_calls,
  driver_delivery_video_call_cancel,
  driver_delivery_video_call_end,
  driver_delivery_video_call_pharmacist_end,
  driver_pharmacist_driver_video_call_initiate,
  driver_pharmacist_driver_video_calls,
  driver_pharmacy_driver_list,
} from '../../networking/urlEndPoints';

export const fetchDriverDeliveryVideoCall = async (callId) => {
  const { data } = await Axios.get(`${driver_delivery_video_calls}/${callId}`);
  return data?.data ?? data;
};

export const acceptDriverDeliveryVideoCall = async (callId, acceptedFrom = 'delivery-app') => {
  const { data } = await Axios.post(`${driver_delivery_video_calls}/${callId}/accept`, {
    accepted_from: acceptedFrom,
  });
  return data?.data ?? data;
};

export const declineDriverDeliveryVideoCall = async (callId, reason = null) => {
  const payload = reason ? { reason } : {};
  const { data } = await Axios.post(`${driver_delivery_video_calls}/${callId}/decline`, payload);
  return data?.data ?? data;
};

export const cancelDriverDeliveryVideoCall = async (callId, reason = null) => {
  const payload = reason ? { reason } : {};
  const { data } = await Axios.post(`${driver_delivery_video_call_cancel}/${callId}/cancel`, payload);
  return data?.data ?? data;
};

export const endDriverDeliveryVideoCall = async (callId) => {
  const { data } = await Axios.post(`${driver_delivery_video_call_end}/${callId}/end`);
  return data?.data ?? data;
};

export const endDriverPharmacistDeliveryVideoCall = async (callId) => {
  const { data } = await Axios.post(`${driver_delivery_video_call_pharmacist_end}/${callId}/pharmacist-end`);
  return data?.data ?? data;
};

export const fetchPharmacistDriverIncomingVideoCall = async (callId) => {
  const { data } = await Axios.get(`${driver_pharmacist_driver_video_calls}/${callId}`);
  return data?.data ?? data;
};

export const acceptPharmacistDriverIncomingVideoCall = async (callId, acceptedFrom = 'delivery-app') => {
  const { data } = await Axios.post(`${driver_pharmacist_driver_video_calls}/${callId}/accept`, {
    accepted_from: acceptedFrom,
  });
  return data?.data ?? data;
};

export const declinePharmacistDriverIncomingVideoCall = async (callId, reason = null) => {
  const payload = reason ? { reason } : {};
  const { data } = await Axios.post(`${driver_pharmacist_driver_video_calls}/${callId}/decline`, payload);
  return data?.data ?? data;
};

export const endPharmacistDriverIncomingVideoCall = async (callId) => {
  const { data } = await Axios.post(`${driver_pharmacist_driver_video_calls}/${callId}/end`);
  return data?.data ?? data;
};

export const endPharmacistDriverIncomingVideoCallOnUnload = (callId) => {
  if (!callId || typeof window === 'undefined' || typeof window.fetch !== 'function') {
    return false;
  }

  const token = Cookies.get('authToken');
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  try {
    window.fetch(buildApiUrl(`${driver_pharmacist_driver_video_calls}/${encodeURIComponent(callId)}/end`), {
      method: 'POST',
      headers,
      body: JSON.stringify({ reason: 'page_refresh' }),
      keepalive: true,
      credentials: 'same-origin',
    }).catch(() => {});
    return true;
  } catch (error) {
    return false;
  }
};

export const fetchPharmacistDriverCallDrivers = async (pharmacyId) => {
  const { data } = await Axios.get(driver_pharmacy_driver_list, {
    params: { pharmacy_id: pharmacyId },
  });
  return data?.data ?? data;
};

export const initiatePharmacistDriverVideoCallFromDeliveryApp = async ({
  driverId,
  pharmacyId,
  pharmacistId,
  deferNotify = false,
}) => {
  const payload = {
    driver_id: driverId,
    pharmacy_id: pharmacyId,
    pharmacist_id: pharmacistId,
  };

  if (deferNotify) {
    payload.defer_notify = true;
    payload.suppress_push = true;
  }

  const { data } = await Axios.post(driver_pharmacist_driver_video_call_initiate, payload);
  return data?.data ?? data;
};

export const cancelPharmacistDriverVideoCallFromDeliveryApp = async (callId, reason = null) => {
  const payload = reason ? { reason } : {};
  const { data } = await Axios.post(`${driver_pharmacist_driver_video_calls}/${callId}/pharmacist-cancel`, payload);
  return data?.data ?? data;
};

export const endPharmacistDriverVideoCallFromDeliveryApp = async (callId) => {
  const { data } = await Axios.post(`${driver_pharmacist_driver_video_calls}/${callId}/pharmacist-end`);
  return data?.data ?? data;
};

const buildApiUrl = (path) => {
  const baseUrl = Axios.defaults.baseURL || process.env.REACT_APP_BASE_URL || '';
  const normalizedPath = String(path || '').replace(/^\/+/, '');

  if (!baseUrl) {
    return `/${normalizedPath}`;
  }

  try {
    return new URL(normalizedPath, baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`).toString();
  } catch (error) {
    return `${String(baseUrl).replace(/\/+$/, '')}/${normalizedPath}`;
  }
};

export const endPharmacistDriverVideoCallFromDeliveryAppOnUnload = (callId) => {
  if (!callId || typeof window === 'undefined' || typeof window.fetch !== 'function') {
    return false;
  }

  const token = Cookies.get('authToken');
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  try {
    window.fetch(buildApiUrl(`${driver_pharmacist_driver_video_calls}/${encodeURIComponent(callId)}/pharmacist-end`), {
      method: 'POST',
      headers,
      body: JSON.stringify({ reason: 'page_refresh' }),
      keepalive: true,
      credentials: 'same-origin',
    }).catch(() => {});
    return true;
  } catch (error) {
    return false;
  }
};
